import API from 'services/api';

export const stornInvoice = ({ invoiceId }: { invoiceId: string }) =>
  API.post(`/api/documents/invoices/${invoiceId}/cancel`);
